var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{ mini: _vm.mini, no_space: _vm.no_space, claro: _vm.claro }},[_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }